<script>
'use strict';

module.exports = {
  name: 'SkeletonProductCard',
};
</script>

<template>
  <div class="product-card skeleton-product-card">
    <div class="skeleton-image skeleton-pulse"></div>
    <div class="skeleton-line skeleton-line-title skeleton-pulse"></div>
    <div class="skeleton-line skeleton-line-price skeleton-pulse"></div>
    <div class="skeleton-button skeleton-pulse"></div>
  </div>
</template>

<style scoped lang="postcss"></style>
